function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMasterCard = function SvgMasterCard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#64B5F6"
    },
    d: "M45,35c0,2.208-1.791,4-4,4H7c-2.209,0-4-1.792-4-4V13c0-2.21,1.791-4,4-4h34c2.209,0,4,1.79,4,4V35z  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 14,
    style: {
      fill: "#37474F"
    },
    width: 42,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 26.435,
    style: {
      fill: "#FF6F00"
    },
    width: 7,
    height: 7.13
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB300"
    },
    d: "M37,25c-1.364,0-2.598,0.549-3.5,1.435C34.424,27.342,35,28.603,35,30s-0.576,2.658-1.5,3.565  C34.402,34.451,35.636,35,37,35c2.761,0,5-2.239,5-5S39.761,25,37,25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D50000"
    },
    d: "M32,30c0-1.397,0.576-2.658,1.5-3.565C32.598,25.549,31.364,25,30,25c-2.761,0-5,2.239-5,5  s2.239,5,5,5c1.364,0,2.598-0.549,3.5-1.435C32.576,32.658,32,31.397,32,30z"
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMasterCard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/master_card.59779012.svg";
export { ForwardRef as ReactComponent };